import {ComponentService} from "./service/component";
import {Application} from "./application/application";

/*import {AosInit} from "./components/aos-init";*/
import {DisplayOnScroll} from "./components/page-scroll-events";
import {SocialComponent} from "./components/social";
import {MobileMenu} from "./components/mobile-menu";
import {ModalComponent} from "./components/modal";
import {SelectricComponent} from "./components/selectric";
import {HeaderScroll} from "./components/header-scroll";
import {DesktopMenuComponent} from "./components/desktop-menu";
import {VideoComponent} from "./components/video";
import {AnnouncementBar} from "./components/announcement-bar";
import {AnnouncementCarouselComponent} from "./components/announcement-carousel";
import {IntroBannerAnim} from "./components/intro-banner-animation";

require("@babel/polyfill");
require('picturefill/dist/picturefill.js');

(($) => $(() => {

    let components = new ComponentService();
    /*components.addComponent('body', AosInit, 'AosInit');*/
    components.addComponent('[data-animated="true"]', DisplayOnScroll);
    components.addComponent('.js-share', SocialComponent, 'SocialComponent');
    components.addComponent('.js-nav-toggle', MobileMenu, 'MobileMenu');
    components.addComponent('.js-modal-trigger', ModalComponent, 'ModalComponent');
    components.addComponent('.js-custom-select', SelectricComponent, 'SelectricComponent');
    components.addComponent('.js-nav-header', HeaderScroll, 'HeaderScrollComponent');
    components.addComponent('.js-primary-navigation', DesktopMenuComponent, 'DesktopMenuComponent');
    components.addComponent('.js-video', VideoComponent, 'VideoComponent');
    components.addComponent('.js-announcement-dismiss', AnnouncementBar, 'AnnouncementBar');
    components.addComponent('.js-announcement-carousel', AnnouncementCarouselComponent, 'AnnouncementCarouselComponent');
    components.addComponent('.js-intro-banner-animation', IntroBannerAnim, 'IntroBannerAnim');

    new Application(components);

}))(jQuery);
